export default "__VITE_ASSET__C3Ez6mum__"